/**
 * Screens ask for simple capabilities ("payroll.read"); this maps them onto the server's
 * permission catalogue (src/auth/permissions.ts) so the UI hides exactly what the API refuses.
 */
import type { Scope } from "./api/types";
type Perms = Record<string, Scope>;
const ALIAS: Record<string, string | ((p: Perms) => Scope | undefined)> = {
  "employee.read": "employee.view", "employee.export": "employee.view",
  "salary.read": "salary.structure.view", "salary.update": "salary.structure.update",
  "attendance.read": "attendance.view", "attendance.adjust": "attendance.edit", "device.manage": "attendance.device.manage",
  "leave.read": "leave.view", "leave.adjust": "leave.balance.adjust",
  "leave.approve": (p) => p["leave.approve.hr"] ?? p["leave.approve.manager"],
  "payroll.read": (p) => (p["payroll.payslip.view"] === "TENANT" ? "TENANT" : undefined),
  "payroll.calculate": "payroll.run.calculate", "payroll.approve": "payroll.run.approve", "payroll.disburse": "payroll.run.approve", "payroll.reopen": "payroll.run.reopen",
  "payslip.read": "payroll.payslip.view", "payslip.send": "payroll.run.approve",
  "policy.manage": (p) => p["attendance.policy.manage"] ?? p["payroll.policy.manage"], "pay.policy.manage": "payroll.policy.manage", "attendance.policy": "attendance.policy.manage",
  "org.manage": "settings.manage", "holiday.manage": "settings.manage", "calendar.manage": "settings.manage",
  "audit.read": "audit.view", "notify.send": "employee.update", "dashboard.read": "dashboard.view",
};
export function scopeOf(perms: Perms, key: string): Scope | undefined {
  const a = ALIAS[key];
  return typeof a === "function" ? a(perms) : perms[a ?? key];
}
